import { render, staticRenderFns } from "./DocumentosPropostaModal.vue?vue&type=template&id=299f87cc&"
import script from "./DocumentosPropostaModal.vue?vue&type=script&lang=js&"
export * from "./DocumentosPropostaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports